<div class="body-container body-padding-5p">
    <div class="block">
        <div class="unauthorized-content">
            <div class="unauthorized-head">
                <i class="fa fa-lock"></i>
                <div>
                    <span>{{ translationManager.getTranslation('Неауторизован приступ') }}</span>
                </div>
            </div>
            <div>
                <span>
                    <i class="fa fa-info"></i>{{ translationManager.getTranslation('Нисте овлашћени за покретање ове опције. Обратите се лицу овлашћеном за администрирање налога Ваше организације.') }}
                </span>
            </div>
            <div>
                <a href="./" class="nav-link"><i class="fa fa-home"></i>{{ translationManager.getTranslation('Почетна страна') }}</a>
            </div>
        </div>
    </div>
    <footer class="footer d-none d-sm-block">
        <div class="footer-inner">
            <div class="h-100 pt-3 border-none border-t-1 brc-default-l1 bgc-white-tp1 shadow">
                <span class="text-primary-m2 font-bolder text-120">Ace</span>
                <span class="text-muted">Application &copy; 2020</span>

                <span class="mx-3 action-buttons">
                    <a href="#" class="text-blue2-m3 text-140"><i class="fab fa-twitter-square"></i></a>
                    <a href="#" class="text-blue-d1 text-140"><i class="fab fa-facebook"></i></a>
                    <a href="#" class="text-orange text-140"><i class="fa fa-rss-square"></i></a>
                </span>
            </div>
        </div><!-- .footer-inner -->
    </footer>

    <div class="footer-tools">
        <a id="btn-scroll-up" href="#"
            class="btn-scroll-up btn btn-white brc-black-tp7 btn-smd border-2 radius-round mb-2 mr-2">
            <i class="fa fa-angle-double-up w-2 h-2"></i>
        </a>
    </div>
</div>
